/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Droplinknoresults3Inputs */

const en_droplinknoresults3 = /** @type {(inputs: Droplinknoresults3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matches`)
};

const de_droplinknoresults3 = /** @type {(inputs: Droplinknoresults3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Treffer`)
};

/**
* | output |
* | --- |
* | "No matches" |
*
* @param {Droplinknoresults3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const droplinknoresults3 = /** @type {((inputs?: Droplinknoresults3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Droplinknoresults3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_droplinknoresults3(inputs)
	return de_droplinknoresults3(inputs)
});
export { droplinknoresults3 as "dropLinkNoResults" }